// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c67d04cb","513":"b45668ec","703":"640bccbb","787":"3fda1bbe"}[chunkId] + ".chunk.js";
};